<template>
  <div class="reset container">
    <div class="row">
      <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
        <card
          page="reset"
        >
          <img
            class="reset__image"
            src="@/assets/logo.png"
            alt="KGB Aviation"
          >
          <form-component>
            <form
              novalidate="novalidate"
              @submit.prevent="doReset"
            >
              <input-text
                id="password"
                v-model="password"
                v-validate="'required'"
                name="password"
                data-vv-name="password"
                data-vv-as="password"
                label="Password"
                type="password"
                required
                :error="errors.first('password')"
              />

              <button
                type="submit"
                :disabled="saving"
                class="btn btn--primary btn--large mt-4"
              >
                <font-awesome-icon
                  v-if="saving"
                  :spin="true"
                  :icon="['fas', 'spinner']"
                  class="icon alt"
                />
                <span v-else>Reset Password</span>
              </button>
            </form>
          </form-component>
          <router-link
            to="/login"
            tag="a"
          >
            Go Back
          </router-link>
        </card>
      </div>
    </div>
  </div>
</template>

<script>

import UserClient from '@/api/UserClient';
import Card from '@/components/Card.vue';
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';

export default {
  name: 'Reset',
  components: {
    Card,
    FormComponent,
    InputText,
  },
  data() {
    return {
      token: '',
      password: '',
      userClient: new UserClient(this.$http),
      saving: false,
    };
  },
  mounted() {
    this.$store.commit('clearGlobalAlerts');

    this.token = this.$route.params.token || '';
  },
  methods: {
    doReset() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.errors.clear();

          this.saving = true;
          this.userClient.resetPassword(this.token, this.password).then(() => {
            this.saving = false;
            this.$router.push({ name: 'login', params: { from: 'reset' } });
          }).catch(() => {
            this.saving = false;
            this.$store.commit('setGlobalAlert', {
              msg: 'Unable to reset password. Please try again.', error: true,
            });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.reset {
  &__image {
    max-width: 200px;
    margin-bottom: $gutter;
  }

  &__card {
    display: block;
    max-width: 450px;
    margin: 0 auto;
    text-align: center;
  }

  .btn {
    display: block;
    width: 100%;
    margin: 5px 0 $gutter !important;
  }

  a {
    color: rgba(0, 0, 0, 0.4);

    &:hover {
      color: $blue;
      text-decoration: none;
    }
  }
}
</style>
